import Typography from "@mui/material/Typography";

export default function DiscountedPrice({ val }) {
  return (
    <Typography gutterBottom sx={{ typography: { md: 'h6', xs: 'body1' }, paddingTop: '10px'}} component="div">
    Only today: {val} nok
    </Typography>
  );
}